import React, { useState, useEffect, useMemo, useCallback } from 'react'
import { InputText } from '../../../ui'
import { useTranslation } from 'react-i18next'
import { useStore } from '../../../StateProvider'
import {
  LATIN_WITH_NUMBERS_SYMBOLS_EXTENDED,
  MAX_LENGTH
} from '../../../constants/constants'
import styles from './style.css'

const ExternalLoginField = ({ i18nLabel, type, name, maxlength, additionalInfo, required }) => {
  const { t } = useTranslation()
  const label = i18nLabel ? t(`createAccount.${i18nLabel}`) : ''
  const [value, setValue] = useState('')
  const [isValid, setIsValid] = useState(null)
  const [isFilled, setIsFilled] = useState(false)
  const [isShown, setIsShown] = useState(false)
  const [error, setError] = useState('')
  const [{ form, form: { accId } }, dispatch] = useStore()
  const { alreadyExistsDiffError, loginExistsError, proposed, email } = form[accId]

  const proposedRender = useMemo(() => {
    if (proposed) {
      return (
        <span className={styles.proposed}>
          {proposed.map((item, i) => {
            const link = <a href='#' onClick={e => onClick(e, item)}>{item}</a>
            if (proposed.length - 1 > i) {
              return <React.Fragment key={item}>{link}, {' '}</React.Fragment>
            }
            return <React.Fragment key={item}>{link}</React.Fragment>
          })}
        </span>
      )
    }

    return null
  }, [proposed])

  useEffect(() => {
    if (alreadyExistsDiffError) {
      dispatch({ type: 'addValidationFld', name: 'login' })
      setIsShown(true)
      setValue(email)
    } else {
      dispatch({ type: 'removeFieldValue', name: 'login' })
      dispatch({ type: 'removeValidationFld', name: 'login' })
    }
  }, [alreadyExistsDiffError])

  useEffect(() => {
    if (loginExistsError) {
      setError('createAccount.loginAlreadyExists')
      dispatch({ type: 'setValidationFld', name, value: false })
    }
  }, [loginExistsError])

  const onClick = useCallback((e, item) => {
    e.preventDefault()
    setValue(item)
    validHandler(name, item)
  }, [name])

  const onChange = ({ target: { value } }) => {
    setValue(value)
    !value.trim() ? setIsFilled(false) : setIsFilled(true)
    dispatch({ type: 'setExtFieldValue', name: 'loginExistsError', value: false })
  }

  const onBlur = ({ target: { name, value } }) => {
    validHandler(name, value)
  }

  const validHandler = (name, value) => {
    const isValid = LATIN_WITH_NUMBERS_SYMBOLS_EXTENDED.test(value.trim())

    if (isValid) {
      setIsValid(true)
      setError('')
      dispatch({ type: 'setExtFieldValue', name, value })
    } else {
      setIsValid(false)
      setError(!isFilled ? '' : 'generatedField.onlyLatin')
    }

    dispatch({ type: 'setValidationFld', name, value: isValid })
  }

  return isShown ? (
    <>
      <span className={styles.error}>
        {t('createAccount.emailExistsOtherApplication')}
        <br />
        {t('createAccount.emailExistsOtherApplication2')}{' '}
        {proposedRender}
      </span>
      <InputText
        name={name}
        label={label}
        value={value}
        type={type}
        key={name}
        maxLength={maxlength || MAX_LENGTH}
        error={t(error)}
        onChange={onChange}
        onBlur={onBlur}
        valid={isValid}
        info={additionalInfo ? `generatedField.${name}AdditionalInfo` : ''}
      />
    </>
  ) : null
}

const getExternalLoginField = textField => {
  const { i18n, required, type, order, maxLength, additionalInfo } = textField
  return (
    <ExternalLoginField
      i18nLabel={i18n}
      name='login'
      required={required}
      type={type}
      key='login'
      order={order}
      additionalInfo={additionalInfo}
      maxlength={maxLength}
    />
  )
}

export { ExternalLoginField, getExternalLoginField }
